import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Cookies from 'js-cookie';
import ElementLocale from 'element-ui/lib/locale';
import elementIdLocale from 'element-ui/lib/locale/lang/id';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import enLocale from './locales/en.json';
import idLocale from './locales/id.json';

Vue.use(VueI18n);

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    id: {
        ...idLocale,
        ...elementIdLocale
    }
};

const i18n = new VueI18n({
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    locale: Cookies.get('language') || 'id',
    messages
});

ElementLocale.i18n((key: any, value: any) => i18n.t(key, value));

export default i18n;

